import angular from 'angular';
import clientPreliminaryAssesment from './clientPreliminaryAssesment';
import './style.scss';

export default angular
  .module('components.clientPreliminaryAssesment', [])
  .component('clientPreliminaryAssesment', clientPreliminaryAssesment).name;
